module.exports = __webpack_public_path__ + "static/media/greyTick.e53dfa51_UI.svg";